"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

function MethodFactory(_ref) {
  var _ref$code = _ref.code,
      code = _ref$code === void 0 ? null : _ref$code,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  switch (code) {
    case 'WMR':
      return /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
        type: 'web-money',
        label: "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B",
        name: "destination",
        disabled: disabled,
        required: true
      });

    case 'WMZ':
      return /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
        type: 'web-money',
        label: "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B",
        name: "destination",
        disabled: disabled,
        required: true
      });

    case 'YandexMoney':
      return /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
        type: 'yandex-money',
        label: "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B",
        name: "destination",
        disabled: disabled,
        required: true
      });

    case 'BankCard':
      return /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
        type: 'bank-card',
        label: "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B",
        name: "destination",
        disabled: disabled,
        required: true
      });

    case 'Mobile':
      return /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
        type: 'phone',
        label: "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B",
        name: "destination",
        disabled: disabled,
        required: true
      });

    case 'Qiwi':
      return /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
        type: 'phone',
        label: "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B",
        name: "destination",
        disabled: disabled,
        required: true
      });

    default:
      return /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
        _data: "payout.destination",
        label: "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B",
        name: "destination",
        disabled: disabled,
        required: true
      });
  }
}

var _default = MethodFactory;
exports["default"] = _default;